<template>
    <div class="col-12 col-md-8 col-lg-9 content mb-20 mb-lg-0 text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-9 content mb-20 mb-lg-0 text-center" v-else-if="!article">
        <p>No article data found</p>
    </div>
    <div class="col-12 col-md-8 col-lg-9 content mb-20 mb-lg-0" v-else>
        <nav class="breadcrumb-wrap">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                <router-link :to="{ name: 'allMatches' }">Planet Cricket</router-link>
                </li>
                <li class="breadcrumb-item">
                <router-link :to="{ name: 'newsList' }">News</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">{{ article.heading.substringWords(30) }}</li>
            </ol>
        </nav>
        <div class="artical-detail">
            <div class="artical-detail-head">
                <div class="video-box">
                    <img v-if="$store.state.isMobile" loading="lazy"  width="970" height="485" :src="article.image_url.resizeImage(970)" :alt="article.heading" />
                    <img v-else width="970" height="485" :src="article.image_url.resizeImage(970)" :alt="article.heading" />
                    <span class="img-credit" v-if="article.credit_image">Photo by "<strong> {{article.credit_image}} </strong>"</span>
                </div>

                <div class="sub-head-line" v-if="article.match">
                    <span class="badge">{{ article.category_id == 22 ? 'Match Preview' : (article.category_id == 23 ? 'Match Report':'') }}</span>
                    <router-link :to="{name: 'matchDetail.Scorecard', params: {match: article.match.slug}}">
                        <span class="match-info">
                            <span>{{ article.match.team1.name }}</span> vs <span>{{ article.match.team2.name }}</span>
                        </span>
                    </router-link>
                </div>
                <h1>{{ article.heading }}</h1>
                <strong class="h3">{{ article.subheading }}</strong>
                <div class="auther-wrap">
                    <div class="auter-img" v-if="article.author == 'Waqar Aslam' || article.author =='Roohan Adeel' || article.author =='Haider Abbas' || article.author == 'Mubasshir Ijaz'"><img :src="'https://img.sixlogics.com/news-authors/'+ article.author_image +'.png'" alt=""></div>
                    <div class="auther-descrip">
                        <strong class="uther" v-if="article.author == 'Waqar Aslam' || article.author =='Roohan Adeel' || article.author =='Haider Abbas' || article.author == 'Mubasshir Ijaz'">{{ article.author }}</strong>
                        <time class="time" :datetime="article.created_at | formatDate('YYYY-MM-DD')">
                              {{ article.created_at | timeElaped }}
                    </time>
                </div>
            </div>
        </div>

        <div class="artical-detail-body" v-html="article.body"></div>
<!--        <div class="artical-detail-body" >{{article.body}}</div>-->
    </div>
    <section class="post-section">
        <div class="post-section-head">
            <strong class="h2 text-uppercase">Related Articles</strong>
            <router-link :to="{ name: 'newsList' }" class="see-all">See All</router-link>
        </div>
        <VueSlickCarousel v-if="relatedArticles.length" class="post-slider" :arrows="true" :dots="false" :variableWidth="true" :infinite="false">
            <div class="slide" v-for="news in relatedArticles" :key="news.id">
                <div class="post">
                    <router-link :to="{ name: 'newsArticle', params: { news: news.slug, ...(news.match) && {match: news.match.slug} } }">
                        <div class="img-holder">
                            <img width="260" height="130" loading="lazy" :src="news.image_url.replace('.jpg', '-big.jpg').resizeImage(260,130)" :alt="news.heading" />
                        </div>
                        <div class="descrip">
                            <h3>{{ news.heading }}</h3>
                            <time class="time" :datetime="news.created_at | formatDate('YYYY-MM-DD')">
                                  {{ news.created_at | timeElaped }}
                        </time>
                    </div>
                </router-link>
            </div>
        </div>
    </VueSlickCarousel>
</section>
<section class="post-section">
    <div class="post-section-head">
        <strong class="h2 text-uppercase">Related Videos</strong>
        <router-link :to="{ name: 'highlights' }" class="see-all">See All</router-link>
    </div>
    <VueSlickCarousel v-if="videos.length" class="post-slider" :arrows="true" :dots="false" :variableWidth="true" :infinite="false">
        <div class="slide" v-for="video in videos" :key="video.id">
            <div class="post">
                <div class="img-holder">
                    <span v-html="video.highlight"></span>
                </div>
                <div class="descrip">
                    <time class="time" :datetime="video.created_at | formatDate('YYYY-MM-DD')">
                          {{ video.created_at | timeElaped }}
                </time>
            </div>
        </div>
    </div>
</VueSlickCarousel>
</section>
</div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        name: 'newsArticle',

        components: {VueSlickCarousel},

        data() {
            return {
                article: null,
                relatedArticles: [],
                videos: []
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                // video schema
            let relatedvideos = []
               this.videos.forEach((video) => {
                relatedvideos.push(
                        {
                            '@type': 'VideoObject',
                            "name": video.title,
                            "description": video.title,
                            "thumbnailUrl": [
                                process.env.BASE_URL + 'public/images/logo1280x720.png'
                            ],
                            "uploadDate": video.created_at,
                            "contentUrl": "https://planetcricket.com" + this.$route.path,
                            "embedUrl": video.video_code,
                        }
                )
            });
            // related articals schema
            let articles = [];
            this.relatedArticles.forEach((article) => {
                articles.push(
                        {
                            '@type': 'NewsArticle',
                            mainEntityOfPage: {
                                '@type': 'WebPage',
                                '@id': "https://planetcricket.com" + this.$route.path
                            },
                            headline: article.heading,
                            description: article.subheading,
                            image: article.image_url,
                            author: {
                                '@type': 'Person',
                                name: article.author,
                                "url" : process.env.BASE_URL
                            },
                            publisher: {
                                '@type': 'Organization',
                                name: 'Planet Cricket',
                                logo: {
                                    '@type': 'ImageObject',
                                    url: process.env.BASE_URL + 'public/images/logo1280x720.png'
                                }
                            },
                            datePublished: article.created_at,
                            dateModified: article.updated_at
                        }
                )
            });
                return {
                '@context': 'https://schema.org',
                '@type': "NewsArticle",
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': "https://planetcricket.com" + this.$route.path
                },
                headline: this.article.heading,
                description: this.article.subheading,
                image: this.article.image_url,
                author: {
                    '@type': 'Person',
                    name: this.article.author,
                    "url" : process.env.BASE_URL
                },
                publisher: {
                    '@type': 'Organization',
                    name: 'Planet Cricket',
                    logo: {
                        '@type': 'ImageObject',
                        url: process.env.BASE_URL + 'public/images/logo1280x720.png'
                    }
                },
                datePublished: this.article.created_at,
                dateModified: this.article.updated_at,
                "@context": "http://schema.org",
                "@graph": [articles,relatedvideos]
            }
        },
        metaInfo() {
            if (!this.article)
                return

            let title = this.article.heading + " - Planet Cricket";
            let description = this.article.subheading.substringWords(160);
            return {
                title: title,
                meta: this.$getMetaTags(title, description, this.article.image_url.resizeImage(1200, 630)),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getArticle();
            }
        },


      mounted() {

            this.getArticle()
        },

      watch: {
            $route() {
                if(isBrowser)
                Components[this.$parent.$options.name + ''].reload++;
//                this.getArticle()
            }
        },

        methods: {

            getArticle() {
                return this.$axios
                        .get(this.$ARTICLE_API.replace(':news', this.$route.params.news).replace(':match', this.$route.params.match))
                        .then(response => {

                            this.is_data_ready = true
                            this.videos = response.data.result.videos || []
                            this.article = response.data.result.article
                            this.relatedArticles = response.data.result.relatedArticles || []
                           // console.log(this.videos)
                          this.$loadScript('https://platform.twitter.com/widgets.js');

                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
        }
    }
</script>
